import Checkbox from "./Input/Checkbox";
import Date from "./Input/Date";
import LongText from "./Input/LongText";
import Number from "./Input/Number";
import Radio from "./Input/Radio";
import Select from "./Input/Select";
import Signature from "./Input/Signature";
import String from "./Input/String";
import Text from './Text/Text';

export const components = {
    "string": String,
    "checkbox": Checkbox,
    "date": Date,
    "long": LongText,
    "number": Number,
    "radio": Radio,
    "select": Select,
    "signature": Signature,
    "text": Text
};